import { CustomFieldCustomization, GetTopicResponse, LogicOperator, VisibilityRule } from '../types';

export function checkTitleFieldVisibility(topic: GetTopicResponse | undefined, currentValues: { [key: string]: string | undefined }) {
    if (!topic?.add_point_customization?.title) {
        return true;
    }
    const hidden = (topic.add_point_customization?.title?.hide ?? false);
    if (!topic.add_point_customization?.title?.visibility_rules) {
        return !hidden;
    }
    const patternMatch = checkPatternMatch(topic.add_point_customization?.title?.visibility_rules, currentValues);
    return !hidden && patternMatch;
}

export function checkDescriptionFieldVisibility(topic: GetTopicResponse | undefined, currentValues: { [key: string]: string | undefined }) {
    if (!topic?.add_point_customization?.description) {
        return true;
    }
    const hidden = (topic.add_point_customization?.description?.hide ?? false);
    if (!topic.add_point_customization?.description?.visibility_rules) {
        return !hidden;
    }
    const patternMatch = checkPatternMatch(topic.add_point_customization?.description?.visibility_rules, currentValues);
    return !hidden && patternMatch;
}

export function checkTagsFieldVisibility(topic: GetTopicResponse | undefined, currentValues: { [key: string]: string | undefined }) {
    if (!topic?.add_point_customization?.tags) {
        return true;
    }
    const hidden = (topic.add_point_customization?.tags?.hide ?? false);
    if (!topic.add_point_customization?.tags?.visibility_rules) {
        return !hidden;
    }
    const patternMatch = checkPatternMatch(topic.add_point_customization?.tags?.visibility_rules, currentValues);
    return !hidden && patternMatch;
}

export function checkMoreInfoFieldVisibility(topic: GetTopicResponse | undefined, currentValues: { [key: string]: string | undefined }) {
    if (!topic?.add_point_customization?.more_info) {
        return true;
    }
    const hidden = (topic.add_point_customization?.more_info?.hide ?? false);
    if (!topic.add_point_customization?.more_info?.visibility_rules) {
        return !hidden;
    }
    const patternMatch = checkPatternMatch(topic.add_point_customization?.more_info?.visibility_rules, currentValues);
    return !hidden && patternMatch;
}

export function checkSpecialOfferFieldVisibility(topic: GetTopicResponse | undefined, currentValues: { [key: string]: string | undefined }) {
    if (!topic?.add_point_customization?.special_offer) {
        return true;
    }
    const hidden = (topic.add_point_customization?.special_offer?.hide ?? false);
    if (!topic.add_point_customization?.special_offer?.visibility_rules) {
        return !hidden;
    }
    const patternMatch = checkPatternMatch(topic.add_point_customization?.special_offer?.visibility_rules, currentValues);
    return !hidden && patternMatch;
}

export function checkPhotosFieldVisibility(topic: GetTopicResponse | undefined, currentValues: { [key: string]: string | undefined }) {
    if (!topic?.add_point_customization?.photos) {
        return true;
    }
    const hidden = (topic.add_point_customization?.photos?.hide ?? false);
    if (!topic.add_point_customization?.photos?.visibility_rules) {
        return !hidden;
    }
    const patternMatch = checkPatternMatch(topic.add_point_customization?.photos?.visibility_rules, currentValues);
    return !hidden && patternMatch;
}

export function checkTermsFieldVisibility(topic: GetTopicResponse | undefined, currentValues: { [key: string]: string | undefined }) {
    if (!topic?.add_point_customization?.terms) {
        return true;
    }
    const hidden = (topic.add_point_customization?.terms?.hide ?? false);
    if (!topic.add_point_customization?.terms?.visibility_rules) {
        return !hidden;
    }
    const patternMatch = checkPatternMatch(topic.add_point_customization?.terms?.visibility_rules, currentValues);
    return !hidden && patternMatch;
}

export function checkEmailFieldVisibility(topic: GetTopicResponse | undefined, currentValues: { [key: string]: string | undefined }) {
    if (!topic?.add_point_customization?.email) {
        return true;
    }
    const hidden = (topic.add_point_customization?.email?.hide ?? false);
    if (!topic.add_point_customization?.email?.visibility_rules) {
        return !hidden;
    }
    const patternMatch = checkPatternMatch(topic.add_point_customization?.email?.visibility_rules, currentValues);
    return !hidden && patternMatch;
}

export function checkDateTimeFieldVisibility(topic: GetTopicResponse | undefined, currentValues: { [key: string]: string | undefined }) {
    if (!topic?.add_point_customization?.date_time) {
        return true;
    }
    const hidden = (topic.add_point_customization?.date_time?.hide ?? false);
    if (!topic.add_point_customization?.date_time?.visibility_rules) {
        return !hidden;
    }
    const patternMatch = checkPatternMatch(topic.add_point_customization?.date_time?.visibility_rules, currentValues);
    return !hidden && patternMatch;
}


export function checkCustomFieldVisibility(customField: CustomFieldCustomization, currentValues: { [key: string]: string | undefined }) {

    const hidden = (customField.customizations.hide ?? false);
    if (!customField.customizations.visibility_rules ||customField.customizations.visibility_rules?.length === 0) {
        return !hidden;
    }

    return !hidden && checkPatternMatch(customField.customizations.visibility_rules, currentValues);
}

export function checkProductVisibility(logic: VisibilityRule[][] | undefined, currentValues: { [key: string]: string | undefined }) {
    if (!logic || logic?.length === 0) {
        return true;
    }
    return checkPatternMatch(logic, currentValues);
}

function checkPatternMatch(rules: VisibilityRule[][], currentValues: { [key: string]: string | undefined }) {
    // Check visibility rules against current values
    // the Key is equal to the targetField. The rule_value has the operator logic like "contains"
    // If the rule is not satisfied, return false
    return rules.every(ruleArray => {
        return ruleArray.some(rule => {
            const currentValue = currentValues[rule.targetField];
            const currentValueLower = currentValue?.toLowerCase();
            const comparisonValue = rule.comparisonValue.toLowerCase();

            switch (rule.operator) {
                case LogicOperator.Contains:
                    return comparisonValue && currentValueLower?.includes(comparisonValue) === true;
                case LogicOperator.NotContains:
                    if (currentValueLower === undefined) {
                        return true;
                    }
                    return comparisonValue && !currentValueLower?.includes(comparisonValue);
                case LogicOperator.Equals:
                    return comparisonValue && currentValueLower === comparisonValue;
                case LogicOperator.NotEquals:
                    return comparisonValue && currentValueLower !== comparisonValue;
                case LogicOperator.IsSet:
                    return currentValue !== undefined;
                case LogicOperator.IsNotSet:
                    return currentValue === undefined;
                case LogicOperator.GreaterThan: {
                    const greaterThanCurrentValue = parseFloat(currentValue ?? '0');
                    const greaterThanComparisonValue = parseFloat(comparisonValue);
                    if (isNaN(greaterThanCurrentValue) || isNaN(greaterThanComparisonValue)) {
                        return true;
                    }
                    return greaterThanCurrentValue > greaterThanComparisonValue;
                }
                case LogicOperator.LessThan: {
                    const lessThanCurrentValue = parseFloat(currentValue ?? '0');
                    const lessThanComparisonValue = parseFloat(comparisonValue);
                    if (isNaN(lessThanCurrentValue) || isNaN(lessThanComparisonValue)) {
                        return true;
                    }
                    return lessThanCurrentValue < lessThanComparisonValue;
                }
                default:
                    return false;
            }
        });
    });
}